/* byLivia — « Complétez le cadeau » : ajout du coffret / de la carte depuis le panier.
   Délégation d'événements au niveau du document : le tiroir se re-rend à chaque
   changement de panier, les boutons sont donc toujours écoutés. Après l'ajout, le tiroir
   se met à jour avec les sections renvoyées par /cart/add.js (même mécanique que Dawn). */
(function () {
  'use strict';
  if (window.__byliviaCartUpsell) return;
  window.__byliviaCartUpsell = true;

  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  /* Sur la page panier (/cart), on recharge la page après l'ajout plutôt que d'ouvrir le tiroir. */
  var onCartPage = !!document.querySelector('cart-items');

  function cartComponent() {
    if (onCartPage) return null;
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('input', function (e) {
    var field = e.target.closest && e.target.closest('[data-upsell-message]');
    if (!field) return;
    var box = field.closest('.cupsell__item');
    var btn = box && box.querySelector('[data-upsell-needs-message]');
    if (btn) btn.disabled = !field.value.trim();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;
    var item = { id: variantId, quantity: 1 };
    if (btn.hasAttribute('data-upsell-needs-message')) {
      var field = btn.closest('.cupsell__item').querySelector('[data-upsell-message]');
      var msg = field ? field.value.trim() : '';
      if (!msg) { if (field) field.focus(); return; }
      item.properties = { 'Message': msg };
    }
    btn.classList.add('is-loading');
    var cart = cartComponent();
    var body = { items: [item] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.classList.remove('is-loading');
      if (!res || res.status) { btn.textContent = 'Réessayer'; return; }
      if (cart && res.sections && typeof cart.renderContents === 'function') {
        cart.renderContents(res);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.open === 'function') cart.open();
      } else {
        /* Page panier sans tiroir : on recharge pour afficher la ligne ajoutée. */
        window.location.reload();
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: res });
      }
    }).catch(function () { btn.classList.remove('is-loading'); });
  });
})();
